import { GreenTick } from "../../../assets/icons";
import CircularProgressIndicator from "../circular-progress-indicator/CircularProgressIndicator";
import styles from "./PrimaryInputWithLoaderBelow.module.scss";

interface Props {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	loading?: boolean;
	loadingLabel?: string;
	loaded?: boolean;
	loadedLabel?: string | null;
	loadedErrorLabel?: string | null;
}

export const PrimaryInputWithLoaderBelow = ({
	value,
	onChange,
	placeholder = "",
	loading = false,
	loadingLabel = "Verifying...",
	loaded = false,
	loadedLabel,
	loadedErrorLabel,
}: Props) => {
	return (
		<div>
			<input
				className={styles.input}
				value={value}
				onChange={e => onChange(e.target.value)}
				placeholder={placeholder}
				type="text"
			/>

			{loading && (
				<div className={styles.statusRow}>
					<CircularProgressIndicator />
					<span className={styles.statusLoading}>{loadingLabel}</span>
				</div>
			)}

			{!loading && loaded && loadedLabel && (
				<div className={styles.statusRow}>
					<GreenTick />
					<span className={styles.statusSuccess}>{loadedLabel}</span>
				</div>
			)}

			{!loading && loaded && loadedErrorLabel && (
				<div className={styles.statusRow}>
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
						<path
							d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
							fill="#ed3237"
						/>
					</svg>
					<span className={styles.statusError}>{loadedErrorLabel}</span>
				</div>
			)}
		</div>
	);
};
